import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import DropdownMenu, { NestedDropdownMenu } from 'react-dd-menu';
import 'react-dd-menu/dist/react-dd-menu.css';
import * as Actions from '../../actions/actions';
import AuthLink from './AuthLink';
import Avatar from '../Helpers/Avatar';
import './Header.css';

import Storage from '../Helpers/Storage/Storage';


class Layout extends Component {
  constructor(props) {
    super(props);
    const { history, resetAlerts } = props;
    this.state = {
      isMenuOpen: false,
      isUserMenuOpen: false
    };
    this.toggleMenu = this.toggleMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.toggleUserMenu = this.toggleUserMenu.bind(this);
    this.closeUserMenu = this.closeUserMenu.bind(this);

    history.listen(() => {
      resetAlerts();
    });
  }

  toggleMenu(e) {
    e.preventDefault();
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
  }

  toggleUserMenu(e) {
    e.preventDefault();
    this.setState({ isUserMenuOpen: !this.state.isUserMenuOpen });
  }

  closeMenu() {
    this.setState({ isMenuOpen: false });
  }

  closeUserMenu() {
    this.setState({ isUserMenuOpen: false });
  }

  render() {
    const {
      currentUserVm,
      authVm: { uid, emailVerified }
    } = this.props;
    const {
      displayName
    } = currentUserVm;
    const { isMenuOpen, isUserMenuOpen } = this.state;
    const menuOptions = {
      isOpen: isMenuOpen,
      close: this.closeMenu,
      align: 'right',
      textAlign: 'left',
      toggle: (
        <a className="mobileToggle" href="#nav" onClick={this.toggleMenu}>
          Menu
          <div>
            <div />
            <div />
            <div />
          </div>
        </a>
      )
    };
    const userMenuOptions = {
      isOpen: isUserMenuOpen,
      close: this.closeUserMenu,
      align: 'right',
      textAlign: 'left',
      toggle: (
        <a href="#usernav" onClick={this.toggleUserMenu}>
          <Avatar alt={displayName} {...currentUserVm} />
        </a>
      )
    };

    return (
      <header>
        <div className="container">
          <Link to="/home">
            <img className="logo" src={Storage.get('logo')} alt="Logo" />
          </Link>
          <nav>
            <div className="wideMenu">
              <AuthLink to="/">Meine Pets</AuthLink>
              <AuthLink to="/search">Suche Pate</AuthLink>

              {uid !== undefined && emailVerified && (
                <DropdownMenu {...userMenuOptions}>
                  <li>
                    <Link to={`/user/${uid}`}>Profil</Link>
                  </li>
                  <li>
                    <Link to="/messages">Nachrichten</Link>
                  </li>
                  <li>
                    <Link to="/logout">Logout</Link>
                  </li>
                </DropdownMenu>
              )}
              <AuthLink to="/home" anon>
                    Home
              </AuthLink>
              <AuthLink to="/login" anon>
                    Login
              </AuthLink>
              <AuthLink to="/register" anon>
                    Registrieren
              </AuthLink>
            </div>
            <div className="mobileMenu">
              <DropdownMenu {...menuOptions}>
                <li>
                  <AuthLink to="/">Meine Pets</AuthLink>
                </li>
                <li>
                  <AuthLink to="/search">Suche Pate</AuthLink>
                </li>

                {uid !== undefined && emailVerified && (
                  <NestedDropdownMenu {...userMenuOptions}>
                    <li>
                      <Link to={`/user/${uid}`}>Profil</Link>
                    </li>
                    <li>
                      <Link to="/messages">Nachrichten</Link>
                    </li>
                    <li>
                      <Link to="/logout">Logout</Link>
                    </li>
                  </NestedDropdownMenu>
                )}
                <li>
                  <AuthLink to="/home" anon>
                    Home
                  </AuthLink>
                </li>

                <li>
                  <AuthLink to="/login" anon>
                    Login
                  </AuthLink>
                </li>
                <li>
                  <AuthLink to="/register" anon>
                    Registrieren
                  </AuthLink>
                </li>
              </DropdownMenu>
            </div>
          </nav>
        </div>
      </header>
    );
  }
}

export default connect(
  state => ({ ...state.currentUserReducer, ...state.authReducer }),
  dispatch => bindActionCreators(Actions, dispatch)
)(withRouter(Layout));



// WEBPACK FOOTER //
// ./src/pages/Header/index.js